export default __webpack_public_path__ + "d7fcb8250f6a6a5026b4413ebd48fd75.ttf";